// extracted by mini-css-extract-plugin
export default {"element":"ConfigurationDownloadButton__element___ODnQ6","icon":"ConfigurationDownloadButton__icon___qMkAn"};